import NavLink from './NavLink';
import NavSearch from './NavSearch';
import TopNavBar from './TopNavBar';
import NavLinkWithIcon from './NavLinkWithIcon';
import NavLinkButton from './NavLinkButton';
import NavBackButton from './NavBackButton';

TopNavBar.NavLink = NavLink;
TopNavBar.NavSearch = NavSearch;
TopNavBar.NavLinkWithIcon = NavLinkWithIcon;
TopNavBar.NavLinkButton = NavLinkButton;
TopNavBar.NavBackButton = NavBackButton;

export default TopNavBar;